import type { FC, PropsWithChildren } from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import { captureException } from '@sentry/react';

import { PageError, type PageErrorProps } from '../pages/page-error';

export type PageErrorBoundaryProps = Omit<PageErrorProps, 'error'>;

export const PageErrorBoundary: FC<
  PropsWithChildren<PageErrorBoundaryProps>
> = ({ children, ...props }) => (
  <ErrorBoundary
    fallbackRender={({ error }) => <PageError error={error} {...props} />}
    onError={(err, info) => captureException(err, { extra: { info } })}>
    {children}
  </ErrorBoundary>
);
